module.exports = __webpack_public_path__ + "img/1F1F9-1F1F3.24c15755.svg";